module.exports = __webpack_public_path__ + "img/userreview.3460e650.png";